<template>
  <div class="editStock column-me">
    <div class="row-me row-center">
      <span class="red-star">*</span>
      <span class="title1 text-justify">库房名称</span>
      <div>：</div>
      <div class="flex1">
        <el-input placeholder="请输入库房名称" style="width: 100%;" clearable v-model="selectItem.name"
                  :class="{'red-border':showRedBorder&&this.$method.isEmpty(this.selectItem.name)}"
                  maxlength="20"></el-input>
      </div>
    </div>
    <div class="row-me row-center margin-top30">
      <span class="red-star">*</span>
      <span class="title1 text-justify">库房管理员</span>
      <div>：</div>
      <div class="flex1">
        <el-select placeholder="请选择库房管理员" style="width: 100%;" filterable clearable
                   v-model="selectItem.mangerId"
                   :class="{'red-border':showRedBorder&&this.$method.isEmpty(this.selectItem.mangerId)}">
          <el-option v-for="item in managerArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row-me margin-top30">
      <span class="red-star-no"></span>
      <span class="title1 text-justify">备注</span>
      <div>：</div>
      <div class="flex1">
        <el-input placeholder="请输入备注" type="textarea" style="width: 100%;" clearable v-model="selectItem.remark"
                  maxlength="500" show-word-limit autosize>
        </el-input>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top200">
      <div class="btn-blank width140 btn-height40" @click="clickClear">取消</div>
      <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSave">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: -1,
    }
  },
  data() {
    return {
      selectItem: {
        name: '',
        type: '',
        mangerId: '',
        remark: '',
      },
      showRedBorder: false,
      managerArray: [], //管理员集合
    }
  },
  // html加载完成之前
  created() {
    this.getManagerArray()
    if (this.id !== -1 && this.id !== '') {
      this.getDetail()
    }
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //取消
    clickClear() {
      this.showRedBorder = false
      this.bus.$emit('editHouseSuccess')
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.selectItem.name) || this.$method.isEmpty(this.selectItem.mangerId)) {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/pharmacy/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('editHouseSuccess')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房详情
    getDetail() {
      this.$getRequest('/admin/pharmacy/get/' + this.id, {}).then((res) => {
        if (res) {
          this.selectItem = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房管理员集合
    getManagerArray() {
      this.$getRequest('/admin/adminUser/list', {}).then((res) => {
        if (res) {
          this.managerArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.editStock {
  padding: 20px;
  overflow: auto;

  .title1 {
    width: 90px;
  }
}
</style>
